import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { faSearch, faX } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit{
  @ViewChild('searchBarInput') searchBarInput!: ElementRef;
  searchText: string = '';
  faSearch = faSearch;
  faX = faX;

  private queryParamsSubscription: Subscription;

  constructor(
    private router: Router,
    private searchService: SearchService,
    private route: ActivatedRoute
  ){
    
  }

  ngOnInit(): void {
    this.searchService.searchText$.subscribe((text) => {
      this.searchText = text;
      if (this.searchBarInput) {
        this.searchBarInput.nativeElement.value = text;
      }
    });
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      if (params.q) {
        this.searchText = params.q;
        
        if (this.searchBarInput) {
          this.searchBarInput.nativeElement.value = params.q;
        }
      }
      else{
        this.searchText = '';
      }
    });
  }

  onSearch(): void {
    const currentUrl = this.router.url;
    const isResultRoute = currentUrl.includes('/home/result');
    const isFeaturedResultRoute = currentUrl.includes('/home/featured-result');
    const currentQueryParams = {...this.route.snapshot.queryParams};

    let targetRoute = '';
    if (isResultRoute) {
      targetRoute = '/home/result';
    } else if (isFeaturedResultRoute) {
      targetRoute = '/home/featured-result';
    }

    if (isResultRoute || isFeaturedResultRoute) {
      const newQueryParams = {
        ...currentQueryParams,
        q: this.searchText.trim()
      };

      delete newQueryParams['p'];
      delete newQueryParams['s'];

      this.router.navigate([targetRoute], { 
        queryParams: newQueryParams 
      });
    } 
    else {
      this.router.navigate(['/home/result'], { 
        queryParams: { q: this.searchText.trim()} 
      });
    }
  }

  clearSearch(manual: boolean = false): void {
    this.searchText = '';
    this.searchService.clearSearchText();
    if(manual){
      this.onSearch();
    }
  }

  onInputChange() {
    this.searchService.setSearchText(this.searchText);
  }

  ngOnDestroy(){
    this.clearSearch();
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }
}
